/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageTotals,
  ToolUsageTotals$inboundSchema,
} from "./toolusagetotals.js";

/**
 * Overall MCP and tool usage totals for the selected filters and time range
 */
export type GetToolUsageTotalsResult = {
  /**
   * Target-aware MCP and tool usage totals
   */
  totals: ToolUsageTotals;
};

/** @internal */
export const GetToolUsageTotalsResult$inboundSchema: z.ZodMiniType<
  GetToolUsageTotalsResult,
  unknown
> = z.object({
  totals: ToolUsageTotals$inboundSchema,
});

export function getToolUsageTotalsResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageTotalsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetToolUsageTotalsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageTotalsResult' from JSON`,
  );
}
